import { INDEX_NEW_NOTIFICATION, INDEX_NEW_POST_DATA, INDEX_AGREEMENT_SHOW } from '../../actions/indexNew';

const indexNewNotification = (state = '', action) => {

    switch (action.type) {

        case INDEX_NEW_NOTIFICATION:

            return action.data;

        case INDEX_AGREEMENT_SHOW:

            return action.data;

        default:

            return state;

    }
};
const indexNewPostData = (state = '', action) => {

    switch (action.type) {

        case INDEX_NEW_POST_DATA:

            return action.data;

        default:

            return state;

    }
};
const indexAgreementShow = (state = '', action) => {

    switch (action.type) {

        case INDEX_AGREEMENT_SHOW:

            return action.data;

        default:

            return state;

    }
};

export default {
    indexNewNotification,
    indexNewPostData,
    indexAgreementShow
};
